export default __webpack_public_path__ + "static/media/folder.113f6c8c.png";